import {ReactNode} from "react";
import {AlertCircle, LoaderCircle} from "lucide-react";
import {Button} from "@/components/ui/button.tsx";

export default function DetailPaneState({title, description, icon, loading = false, onRetry}: {
    title: string;
    description?: string;
    icon?: ReactNode;
    loading?: boolean;
    onRetry?: () => void;
}) {
    return (
        <div className="grid size-full place-content-center text-center text-muted-foreground">
            <div className="mx-auto mb-3">
                {loading ? <LoaderCircle className="size-10 animate-spin"/> : icon ?? <AlertCircle className="size-10"/>}
            </div>
            <p role={loading ? "status" : undefined} className="font-medium text-foreground">{title}</p>
            {description && <p className="mt-1 text-sm">{description}</p>}
            {onRetry && <Button className="mt-3" variant="outline" size="sm" onClick={onRetry}>Erneut laden</Button>}
        </div>
    );
}
